import React, { ReactElement } from 'react'
import styles from './MobileSupporterScreen.module.scss'
import { DesktopButton, MobileBodyLarge, MobileHeadlineLarge } from '../../Typography'
import { ROUTES } from '../../config/routes'
import { useNavigate } from 'react-router-dom'
import { SupporterScreenData } from './SupporterScreen'

type Props = {
  data: SupporterScreenData
}

export const MobileSupporterScreen = ({ data }: Props): ReactElement => {
  const navigate = useNavigate()

  return (
    <div className={styles.container}>
      <div className={styles.textContainer}>
        <MobileHeadlineLarge>Werde FIGHTBACK-WRESTLING Supporter Mitglied!</MobileHeadlineLarge>
        <MobileBodyLarge>
          Wenn du ein Teil von FIGHTBACK-WRESTLING bist und uns unterstützen möchtest, dann kannst
          du das jetzt tun.
          <br />
          Werde ein Supporter Mitglied und genieße folgende Vorteile und Vergünstigungen:
        </MobileBodyLarge>
        <img src={data.fanImageUrl} className={styles.fanImage} alt={'Fan Image'} />
      </div>
      <div className={styles.textContainer}>
        <img src={data.supporterLogoUrl} className={styles.logo} alt={'Supporter Logo'} />
        <MobileHeadlineLarge>Supporter</MobileHeadlineLarge>
        <MobileBodyLarge>
          {' \u2022 '} 15 € pro Monat
          <br />
          {' \u2022 '} Ticket Rabatt – 3,00 € (VVK bei FIGHTBACK, nicht über Ticket Regional)
          <br />
          {' \u2022 '} 10% Nachlass auf Merchandise (Außer Energiedrink)
          <br />
          {' \u2022 '} Early Entry – 5-10 Minuten früher in der Halle / am Platz
          <br />
          {' \u2022 '} Freier Eintritt bei Open Sunday Events
        </MobileBodyLarge>
      </div>
      <div className={styles.textContainer}>
        <img
          src={data.supporterPremiumLogoUrl}
          className={styles.logo}
          alt={'Supporter Premium Logo'}
        />
        <MobileHeadlineLarge>Supporter Premium</MobileHeadlineLarge>
        <MobileBodyLarge>
          {' \u2022 '} 20 € pro Monat
          <br />
          {' \u2022 '} Ticket Rabatt – 5,00 € (VVK bei FIGHTBACK, nicht über Ticket Regional)
          <br />
          {' \u2022 '} 10% Nachlass auf Merchandise (Außer Energiedrink)
          <br />
          {' \u2022 '} Early Entry – 5-10 Minuten früher in der Halle / am Platz
          <br />
          {' \u2022 '} Wenn gewünscht, reservierte Plätze in der ersten Reihe (bei Shows mit freier
          Platzwahl)
          <br />
          {' \u2022 '} Freier Eintritt bei Open Sunday Events
          <br />
          {' \u2022 '} Surprise Merch Box bei Beitritt als Supporter Premium
        </MobileBodyLarge>
      </div>
      <div
        className={styles.button}
        onClick={(): void =>
          navigate(ROUTES.contact, {
            state: 'Ich möchte FIGHTBACK Supporter werden',
            replace: true,
          })
        }
      >
        <DesktopButton darkFont={true}>Supporter werden</DesktopButton>
      </div>
    </div>
  )
}
